export default __webpack_public_path__ + "67d785861580dc11c52e607fc2481ddb.svg";